import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { rootUrl } from '../../../helpers';
import SlidingDiv from '../../../components/slidingDiv';
import { useAuth } from '../../../context/auth-context';
import { GiCheckMark } from 'react-icons/gi';

const ProcessedStockPage = () => {
  const [processedStock, setProcessedStock] = useState([]);
  const [claimingStockId, setClaimingStockId] = useState(null);
  const [selectedStocks, setSelectedStocks] = useState([]); // To hold selected stocks
  const [totalWeight, setTotalWeight] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [isSlidingDivVisible, setIsSlidingDivVisible] = useState(false);
  const [selectedMineral, setSelectedMineral] = useState(0);

  const toggleSlidingDiv = () => {
    setIsSlidingDivVisible(!isSlidingDivVisible);
  };

  // Fetch processed stock data
  const fetchProcessedStock = async () => {
    try {
      const response = await axios.get(rootUrl('/get-processed-stock'));
      setProcessedStock(response.data.data);
    } catch (error) {
      console.error('Error fetching processed stock', error);
      toast.error('Failed to fetch processed stock');
    }
  };

  const auth = useAuth()

  function generateRandom5DigitNumber() {
    return Math.floor(Math.random() * 90000) + 10000;
  }
  // Claim selected stock(s)
  const claimSelectedStock = async () => {
    try {
      
      const response = await axios.post(rootUrl('/claim-stock'), { stock_ids: selectedStocks, uid:auth.user.id, reciept: generateRandom5DigitNumber()});
      if (response.status === 200) {
        toast.success('Stock(s) claimed successfully');
        setSelectedStocks([]); // Clear selected stocks
        setTotalWeight(0); // Reset total weight
        setTotalValue(0); // Reset total value
        fetchProcessedStock(); // Refresh the stock list
      } else {
        toast.error('Failed to claim selected stock(s)');
      }
    } catch (error) {
      console.error('Error claiming stock(s)', error);
      toast.error('Error claiming stock(s)');
    }
  };

  // Effect to load processed stock on page load
  useEffect(() => {
    fetchProcessedStock();
  }, []);

  // Handle selecting/deselecting a stock
  const handleStockSelection = (stockId, weight) => {
    if (selectedStocks.includes(stockId)) {
      setSelectedStocks(selectedStocks.filter(id => id !== stockId));
      setTotalWeight(totalWeight - parseFloat(weight));
      setTotalValue(totalValue - parseFloat(weight) * 84); // Assuming price is $85 per gram
    } else {
      setSelectedStocks([...selectedStocks, stockId]);
      setTotalWeight(totalWeight + parseFloat(weight));
      setTotalValue(totalValue + parseFloat(weight) * 85);
    }
  };

  // View report for selected mineral
  const viewReport = (id) => {
    setIsSlidingDivVisible(true);
    setSelectedMineral(id);
  };

  const approve = async (id)=> {

    try {
      
      const response = await axios.post(rootUrl('/approve'), { sid: id, uid:auth.user.id});
      if (response.status === 200) {
        toast.success('Stock(s) claimed successfully');
        setSelectedStocks([]); // Clear selected stocks
        setTotalWeight(0); // Reset total weight
        setTotalValue(0); // Reset total value
        fetchProcessedStock(); // Refresh the stock list
      } else {
        toast.error('Failed to claim selected stock(s)');
      }
    } catch (error) {
      console.error('Error claiming stock(s)', error);
      toast.error('Error claiming stock(s)');
    }

  }

  return (
    <div className="container mx-auto p-4">
      
      <div>
        <h2 className="text-xl font-bold flex items-center"> <GiCheckMark/> Processed Stock</h2>
        </div>

        <hr className='my-3' />

      <SlidingDiv
        isVisible={isSlidingDivVisible}
        onClose={toggleSlidingDiv}
        width="w-1/2"
        backgroundColor="bg-white"
        textColor="text-black"
      >
        <div className="border rounded-lg p-4 text-gray-800">
          <div className="font-bold text-lg text-center">
            <div className="flex justify-center">
              <img src="/logo1.png" className="w-24" alt="Logo" />
            </div>
            <span>Ministry of Mines and Development</span>
            <br />
            <span>Mineral Valuation Certificate</span>
          </div>

          {/* Dynamically Displaying Mineral Details */}
          {processedStock.length > 0 && selectedMineral ? (
            <>
              {processedStock
                .filter((mineral) => mineral.mineral_id === selectedMineral)
                .map((mineral) => (
                  <div key={mineral.mineral_id}>
                    <div>Date: {mineral.date.substring(0, 10)}</div>
                    <div>Issued to: {mineral.name}</div>

                    <div className="font-semibold my-3">Details</div>
                    <div>Mineral: Gold</div>
                    <div>Sub-Type: {mineral.type}</div>
                    <div>Processing method: {mineral.prim}</div>
                    <div>Gross Weight: {mineral.init_weight} grams</div>
                    <div>Net Weight: {mineral.weight} grams</div>
                    <div>Purity: {mineral.percentage}</div>

                    <div className="my-3">
                      <span>LME Price at: ${84}</span>
                      <span className="ml-5">Valuation: ${parseFloat(mineral.weight) * 84}</span>
                    </div>

                    <div>
                      <p>
                        I've examined the articles, and in my opinion, the figure given above represents the total value of such items only for the purpose stated.
                      </p>
                    </div>

                    <div className="my-5">Authorized Signature: ..............</div>
                  </div>
                ))}
            </>
          ) : (
            <div>No mineral selected or data available.</div>
          )}
        </div>
      </SlidingDiv>

      {/* Processed Stock Table */}
      <table className="min-w-full table-auto border-collapse border border-gray-200">
        <thead>
          <tr className="bg-gray-100">
          {auth.user.userType == 2 && (
                     <th className="px-4 py-2 text-left">
            
                     <input
                       type="checkbox"
                       onChange={() => {
                         if (selectedStocks.length === processedStock.length) {
                           setSelectedStocks([]);
                           setTotalWeight(0);
                           setTotalValue(0);
                         } else {
                           const allStockIds = processedStock.map(stock => stock.id);
                           const allStockWeights = processedStock.reduce((sum, stock) => sum + parseFloat(stock.weight), 0);
                           const allStockValue = processedStock.reduce((sum, stock) => sum + (parseInt(stock.weight) * 85), 0);
                           setSelectedStocks(allStockIds);
                           setTotalWeight(allStockWeights);
                           setTotalValue(allStockValue);
                         }
                       }}
                     />
                   </th>
              )}
         
            <th className="px-4 py-2 text-left">Mineral</th>
            <th className="px-4 py-2 text-left">Weight (grams)</th>
            <th className="px-4 py-2 text-left">Price ($)</th>
            <th className="px-4 py-2 text-left">Status</th>
            <th className="px-4 py-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {processedStock.length === 0 ? (
            <tr>
              <td colSpan="6" className="px-4 py-2 text-center">No processed stock available</td>
            </tr>
          ) : (
            processedStock.map((stock) => (
              <tr key={stock.id}>
                {auth.user.userType == 2 && (
                  <td className="px-4 py-2">
                  <input
                    type="checkbox"
                    checked={selectedStocks.includes(stock.id)}
                    onChange={() => handleStockSelection(stock.id, stock.weight)}
                  />
                </td>
                )}
                
                <td className="px-4 py-2">{stock.type}</td>
                <td className="px-4 py-2">{stock.weight}</td>
                <td className="px-4 py-2">${(stock.weight * 85).toFixed(2)}</td>
                <td className="px-4 py-2">{stock.status}</td>
                <td className="px-4 py-2">
                  {stock.status === 'Assessed' && (
                    <div>
                      <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        onClick={() => viewReport(stock.mineral_id)}
                      >
                        Report
                      </button>
                    </div>
                  )}
                  {stock.status === 'Approve' && auth.user.userType == 3 && (
                    <div>
                      <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        onClick={() => approve(stock.mineral_id)}
                      >
                        Approve
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Display selected stock info */}
      {selectedStocks.length > 0 && (
        <div className="mt-4">
          <div>Total Weight: {totalWeight} grams</div>
          <div>Total Value: ${totalValue.toFixed(2)}</div>
          <button
            className="bg-green-500 text-white px-4 py-2 rounded mt-2"
            onClick={claimSelectedStock}
          >
            Claim Selected Stock(s)
          </button>
        </div>
      )}
    </div>
  );
};

export default ProcessedStockPage;
